import { removeSearchParamFromUrl } from './remove-search-param-from-url';

const ID_TOKEN_PARAM = 'idToken';

export const getSearchParamIdToken = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(ID_TOKEN_PARAM) ?? undefined;
};

export const removeIdTokenFromUrl = (): void =>
  removeSearchParamFromUrl(ID_TOKEN_PARAM);
